import { m8API } from 'services/production/m8';
import { UpdatePartnerCodeService } from 'types/services';

export const updatePartnerCode: UpdatePartnerCodeService = async (params) => {
  return m8API.admin.generateNewPartnerCode({ idPartner: params.partnerId });
};
